var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 65 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.1 32.3C23.3 32.3 16.1 25.1 16.1 16.3C16.1 7.49999 23.3 0.299988 32.1 0.299988C40.9 0.299988 48.1 7.49999 48.1 16.3C48.1 25.1 40.9 32.3 32.1 32.3ZM32.1 5.69999C26.2 5.69999 21.4 10.5 21.4 16.4C21.4 22.3 26.3 27 32.1 27C37.9 27 42.8 22.2 42.8 16.3C42.8 10.4 38 5.69999 32.1 5.69999Z",
    fill: "#E8E9EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.80004 53.7C2.00004 53.7 1.20004 53.4 0.700044 52.6C-0.399956 51.5 -0.0999565 49.7 1.00004 48.9C9.80004 41.7 20.7 37.7 32.2 37.7C43.7 37.7 54.6 41.7 63.1 48.9C64.2 50 64.4 51.6 63.4 52.6C62.3 53.7 60.7 53.9 59.7 52.9C52.1 46.5 42.3 43 32.1 43C21.9 43 12.1 46.5 4.40004 53.1C4.10004 53.4 3.30004 53.7 2.80004 53.7Z",
    fill: "#E8E9EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.d48a4772.svg";
export { ForwardRef as ReactComponent };